import {ShapeCommand} from '../commands.template';

export class ActivityAddLinkedDiagramCommand extends ShapeCommand {
  services: any;
  constructor(data) {
    super(data);
  }

  public execute() {
    const action = {
      linkDiagramAsDrilldown: {
        type: 'activity',
        itemMxKey: Number(this.object.itemMxKey),
        diagram: this.object.diagram
      }
    };

    return this.services.diagramUpdateSvc.update(action, true);
  }

  public reverse() {
    const action = {
      removeLinkedDiagram: {
        itemMxKey: Number(this.object.itemMxKey)
      }
    };

    return this.services.diagramUpdateSvc.update(action, true);
  }
}
